<template>
    <div
        class="popup-overlay with-content"
        :class="{ 'loading': loading, 'active': active, 'docked': docked }"
        @click.self="closePopup()"
    >
        <transition name="fade">
            <div class="popup-main" :class="widthClass[size]">
                <div class="popup-header-main">
                    <div class="popup-header">
                        <div class="popup-header-text" v-html="heading ?? ''"></div>
                        <button class="popup-close" aria-label="close" @click.prevent="closePopup()">&nbsp;</button>
                    </div>
                </div>
                <div class="popup-content !px-2">
                    <slot></slot>
                </div>
                <div class="popup-footer">

                    <button
                        v-if="buttons.cancel"
                        @click.prevent="this.closePopup"
                        class="button cyan-clear rounded-lg mr-4 px-12"
                        v-html="buttons.cancel"
                    ></button>

                    <button
                        v-if="buttons.clear"
                        @click.prevent="emit('popup-handle-clear', this.reference)"
                        class="button cyan-clear rounded-lg mr-4 px-12"
                        v-html="buttons.clear"
                    ></button>

                    <button
                        v-if="buttons.apply"
                        @click.prevent="apply"
                        class="button rounded-lg xl:rounded-br-3xl cta"
                        v-html="buttons.apply"
                    ></button>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>

export default {

    //popup with docked content
    name: 'PopupWithContent',

    props: ['reference', 'heading', 'buttons'],

    data() {
        return {
            isDocked: false,
            active: true,
            docked: true,

            defaultSize: 5,
            size: 5,
            content: '',
            loading: false,
        }
    },

    created() {
        this.activeReference = this.reference;
    },

    mounted() {

        this.Bus.on('open-popup', (reference) => {
            if (reference === this.reference) {
                this.activate();
            }
        });

        this.Bus.on('close-popup', (reference) => {
            if (reference === this.reference) {
                this.closePopup();
            }
        });

        document.body.addEventListener('keydown', this.handleKeyDown);
    },

    methods: {

        apply() {
            this.Bus.emit('popup-handle-apply', this.reference)
        },

        activate() {
            this.active = true;
            this.docked = false;

            this.Bus.emit('set-popup-active-class');
        },

        deactivate() {
            this.active = false;
            this.docked = true;

            setTimeout(() => {
            }, 300);

            this.Bus.emit('set-popup-inactive-class');
        },

        closePopup() {
            this.deactivate();
            this.Bus.emit('hide-flash-message');
            this.Bus.emit('popup-closed', this.activeReference);
        },

        reset() {
            this.buttons = {};
            this.size = this.defaultSize;
        },

        handleKeyDown(event) {
            if (event.key === 'Escape') {
                this.closePopup();
            }
        },
    },

    computed: {
        widthClass() {
            return {
                1:      'max-w-xl',
                2:      'max-w-2xl',
                3:      'max-w-3xl',
                4:      'max-w-4xl',
                5:      'max-w-5xl',
                6:      'max-w-6xl',
                7:      'max-w-7xl',
                0:      '',
            };
        }
    }

};
</script>
